import { render, staticRenderFns } from "./History.vue?vue&type=template&id=e10fe7a4&scoped=true&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"
import style0 from "./History.vue?vue&type=style&index=0&id=e10fe7a4&lang=scss&scoped=true&"
import style1 from "./History.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10fe7a4",
  null
  
)

export default component.exports